import React, { Component } from "react";
import {
  KeyboardAvoidingView,
  View,
  TouchableHighlight,
  StyleSheet,
  Platform,
  Dimensions,
  ScrollView,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import * as Actions from "../actions/ApiActions";
import Loading from "../components/Loading";
import { translate } from "../locales/translate";
import FilterItem from "../components_v2/FilterItem";
import { englishToPersianNumber } from "../util";
import Theme from "../argon-ui/Theme";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faPlus, FONT_FAMILIES } from "../../assets/consts/faCharCodes";
import { IconButton } from "../components_v2/Buttons";
import OrderListItem from "./components/OrderListItem";
import { getIconPicture } from "./components/Icons";
import InputBase from "../nativeBase-ui/InputBase";
import Select from "../nativeBase-ui/Select";
import InputSearch from "../components_v2/InputSearch";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import { Toast } from "native-base";
import ToastAlert from "../nativeBase-ui/ToastAlert";
import ModalBase from "../nativeBase-ui/ModalBase";

const SCREEN_WIDTH = Dimensions.get("window").width;
var AppStyle = require("../styles/Style");
class ParkingScreen extends Component {
  constructor(props) {
    super(props);
    this.orderStatuses = ["ALL"];
    this.state = {
      accessToken: "",
      serverUrl: "",
      isLoading: true,
      isUserValid: "",
      isLoadingError: false,
      userBalance: -1,
      unitBalance: [],
      orderDescriptionFilter: "",
      parkingInfo: null,
      orderStatusFilter: "ALL",
      isNewOrder: false,
      showModal: 0,
      newOrderUnitId: null,
      isService: false,
      orderSelected: null,
      areaList: [],
      isOrderRegistering: true,
      paymentDetails: "",
      reservationUser: null,
      isParkingActive: false,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.Parking"),
  });
  componentDidMount() {
    let { currentServer, serverUrl } = this.props.appReducer;
    var _serverUrl = serverUrl;
    if (!_serverUrl.endsWith("/")) {
      _serverUrl = _serverUrl + "/";
    }
    const accessToken = currentServer.accessToken;
    this.setState({ accessToken, serverUrl: _serverUrl }, () => {
      this.getUser().then(() => {
        this.props.MyOrders(accessToken);
        this.setState({ isLoading: false });
        this.getUserAreas();
        this.getParkingInfo();
      });
    });
  }
  // === show toast => toast native-base ===
  showToast = (message, status = "error") => {
    const toastDetail = {
      title: message,
      variant: "subtle",
      status,
    };
    Toast.show({
      duration: 2000,
      render: () => {
        return <ToastAlert {...toastDetail} />;
      },
    });
  };

  hideModal = () => {
    this.setState({
      showModal: 0,
      isService: false,
      orderSelected: null,
      newOrderUnitId: null,
      isOrderRegistering: true,
    });
  };
  hideCancelConfirm() {
    this.setState({
      isShowingCancelAlert: false,
    });
  }

  PressOnAddButton = () => {
    if (this.state.parkingInfo?.numActive == 0) {
      this.showToast(translate("parking.disActive"), "info");
      return;
    } else {
      this.getUserAreas();
      // this.getUnitsBalance();
      this.setState({
        isNewOrder: true,
        showModal: 1,
        isOrderRegistering: true,
      });
    }
  };
  handleOnItemPress = (orderId, orderData) => {
    this.setState({ orderSelected: orderData, showModal: 2 });
  };

  getBalanceAmount(unitId) {
    return new Promise((resolve, reject) => {
      let { accessToken, serverUrl } = this.state;
      var url = `${serverUrl}Services/GetBalance/`;
      var args = [];

      if (unitId != null) {
        args.push(`UnitCode=${unitId}`);
      }
      if (args.length > 0) {
        url += `?${args.join("&")}`;
      }
      fetch(url, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errors == "NoAccess" || resj.errorCode != null) {
            this.setState({ isUserValid: "No" });
          } else {
            this.setState(
              {
                isUserValid: "Yes",
                userBalance: resj.userBalance,
                unitBalance: resj.unitBalance,
              },
              () => {
                resolve();
              }
            );
          }
        })
        .catch((err) => {
          {
            console.log(err, "balanceAmount");
            // this.showModalToast(translate("api.getBalanceError"));
            reject(err);
          }
        });
    });
  }
  getUserAreas() {
    let { serverUrl, accessToken } = this.state;
    var url = `${serverUrl}Services/GetRibbonUserInUnit/`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
          this.setState({ isUserValid: "No" });
        } else {
          var areas = [];
          for (var i in resj) {
            // this.getBalanceAmount(resj[i].numUnitRef);
            areas.push({
              label: resj[i].strUnitName,
              value: resj[i].numUnitRef,
            });
          }
          if (Platform.OS == "web") {
            areas.unshift({
              label: translate("api.orderUnit"),
              value: "orderUnit",
            });
          }
          this.setState({
            areaList: areas,
          });
        }
      })
      .catch((err) => {
        {
          console.log(err, "get userInUnit have error ");
          reject(err);
        }
      });
  }

  getUser() {
    return new Promise((resolve, reject) => {
      let { serverUrl, accessToken } = this.state;

      var url = `${serverUrl}Services/GetRibbonUser/`;
      fetch(url, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
            this.setState({ isUserValid: "No" }, () => {
              resolve();
            });
          } else {
            this.setState({ reservationUser: resj, isUserValid: "Yes" });
            resolve();
          }
        })
        .catch((err) => {
          {
            console.log(err, "get user have error ");
            reject(err);
          }
        });
    });
  }
  getParkingInfo() {
    let { serverUrl, accessToken } = this.state;
    var url = `${serverUrl}Services/GetParkingInfo/`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess") {
          this.showToast(translate("api.serviceNoAccess"));
        } else {
          this.setState({
            parkingInfo: resj,
            isParkingActive: resj.isActiveService,
          });
          if (this.state.parkingInfo?.numDurationService != 0) {
            this.setState({ isService: true });
          }
        }
      })
      .catch((err) => {
        {
          console.log(err);
          this.setState({ isLoadingPaymentDetails: false });
          // this.showModalToast(translate("api.getCarWashServiceTypeError"));
        }
      });
  }
  cancelOrder() {
    const cancelState = 6;
    if (this.state.orderSelected.numRequestStatus == cancelState) {
      this.showToast(translate("api.canceled"), "info");
      return;
    }
    let { serverUrl, accessToken } = this.state;
    var args = [];
    args.push(`RequestID=${this.state.orderSelected.numRequestID}`);
    var url = `${serverUrl}Services/PutParkingOrderCancel/?${args.join("&")}`;
    fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess") {
          this.showToast(translate("api.cancelNoAccess"));
        } else if (resj.errorCode != null) {
          this.showToast(translate("api.cancelNoAccess"));
        } else {
          // this.showModalToast(translate("api.cancelSuccess"));
          this.getRefreshOrderList();
        }
      })
      .catch((err) => {
        {
          console.log(err);
          // this.showModalToast(translate("api.cancelError"));
        }
      });
  }

  registerParkingOrder() {
    if (
      this.state.newOrderPaymentItem != null &&
      Number.isInteger(this.state.newOrderPaymentItem) &&
      this.state.newOrderUnitId != null &&
      Number.isInteger(this.state.newOrderUnitId)
    ) {
      let { serverUrl, accessToken } = this.state;
      let args = [];

      args.push(`UnitCode=${this.state.newOrderUnitId}`);
      if (this.state.newOrderDescribe) {
        args.push(`RequestDesc=${this.state.newOrderDescribe}`);
      } else {
        args.push(`RequestDesc=${"-"}`);
      }
      args.push(`PaymentType=${this.state.newOrderPaymentItem}`);
      args.push(`Amount=${this.state.parkingInfo?.numBasePrice}`);

      var url = `${serverUrl}Services/PostParkingRegisterOrder/?${args.join(
        "&"
      )}`;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errorCode != null) {
            this.showToast(resj.errorMessage);
            this.setState({ isOrderRegistering: true });
          } else {
            if (this.state.newOrderPaymentItem != 4) {
              this.hideModal();
              this.props.MyOrders(this.state.accessToken);
              // this.showModalToast(translate("api.RegisteredNewOrder"));
            }
            if (this.props.reducer.confirm) {
              this.showToast(translate("api.registeredNewOrder"), "success");
              this.hideModal();

              this.props.MyOrders(this.state.accessToken);
            } else {
              this.showToast(
                translate("api.noPaymentOnlineSuccessFul"),
                "info"
              );
              this.hideModal();
              this.props.MyOrders(this.state.accessToken);
            }
          }
        })
        .catch((err) => {
          {
            console.log(err);
          }
        });
    } else if (
      this.state.newOrderPaymentItem == null ||
      Number.isInteger(this.state.newOrderPaymentItem)
    ) {
      this.showToast(translate("api.requirePaymentMethod"), "info");
    } else if (
      this.state.newOrderUnitId == null ||
      Number.isInteger(this.state.newOrderUnitId)
    ) {
      this.showToast(translate("api.enterUnit"));
    }
    this.setState({ isOrderRegistering: true });
  }
  render() {
    if (this.state.isUserValid == "No") {
      return (
        <View
          style={{ alignItems: "center", flex: 1, justifyContent: "center" }}
        >
          <Text style={{ fontSize: 20, color: "#666666" }}>
            {translate("api.invalidUserReserveApi")}
          </Text>
        </View>
      );
    } else if (this.state.isLoading || this.props.reducer.isLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    } else if (this.state.isLoadingError) {
      return (
        <View
          style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
        >
          <Text
            style={{
              color: Theme.COLORS.ERROR,
              textAlign: "center",
            }}
          >
            {translate("app.loadingError")}
          </Text>
        </View>
      );
    }
    var orderList = [];
    var hasOrder = undefined;
    const shortSupply = 7;
    const underInvestigation = 2;
    var allOrderList = this.props.reducer.ParkingList;
    orderList = allOrderList.filter((o) => {
      if (
        (this.state.orderStatusFilter == "ALL" ||
          o.data.numRequestStatus == this.state.orderStatusFilter ||
          (this.state.orderStatusFilter == underInvestigation &&
            o.data.numRequestStatus == shortSupply)) &&
        (!this.state.orderDescriptionFilter ||
          o.data.strRequestDesc.indexOf(this.state.orderDescriptionFilter) >= 0)
      )
        return o;
    });
    orderList.sort((a, b) =>
      a.dtRegPDate < b.dtRegPDate ? 1 : a.dtRegTime < b.dtRegTime ? 1 : -1
    );
    if (this.props.reducer.ParkingList.length == 0) {
      hasOrder = "No";
    }
    if (this.props.reducer.ParkingList.length != 0) {
      hasOrder = "Yes";
    }

    // orderStatuses
    if (allOrderList && allOrderList.length > 0) {
      this.orderStatuses = ["ALL"];
      for (var i in allOrderList) {
        var status = allOrderList[i].data.numRequestStatus;
        if (this.orderStatuses.indexOf(status) < 0 && status != shortSupply) {
          this.orderStatuses.push(status);
        }
        if (status == shortSupply) {
          this.orderStatuses.push(underInvestigation);
        }
      }
    }
    var paymentType_Options = [];
    const unitBalance = 1;
    const userBalance = 2;
    const cashPayment = 3;
    if (this.state.parkingInfo?.numHasCashPayment) {
      paymentType_Options.push({
        value: cashPayment,
        label: `${translate("api.cashPayment")}`,
      });
    }
    if (
      this.state.parkingInfo?.numHasCreditPayment &&
      this.state.unitBalance != null &&
      this.state.unitBalance >= this.state.parkingInfo?.numBasePrice
    ) {
      paymentType_Options.push({
        value: unitBalance,
        label: `${translate("api.creditUnitPayment")}(${englishToPersianNumber(
          this.state.unitBalance,
          ","
        )} ${translate("api.priceUnit")} )`,
      });
    }

    if (
      this.state.parkingInfo?.numHasCreditPayment &&
      this.state.userBalance >= this.state.parkingInfo?.numBasePrice
    ) {
      paymentType_Options.push({
        value: userBalance,
        label: `${translate("api.creditUserPayment")} (${englishToPersianNumber(
          this.state.userBalance,
          ","
        )} ${translate("api.priceUnit")} )`,
      });
    }
    if (Platform.OS == "web") {
      paymentType_Options.unshift({
        label: translate("api.paymentType"),
        value: "paymentType",
      });
    }

    return (
      <KeyboardAvoidingView behavior="padding" style={{ flex: 1 }}>
        {this.state.isUserValid == "Yes" && (
          <View style={{ flex: 1 }}>
            {/* TouchableFilters */}
            <FilterItem
              listItem={this.orderStatuses.map((s) => {
                return { value: s, text: translate(`api.orderStatuses.${s}`) };
              })}
              selectedItem={
                this.state.orderStatusFilter || this.orderStatuses[0]
              }
              onSelect={(item) => {
                this.setState({ orderStatusFilter: item });
              }}
            />
            <View
              style={[
                AppStyle.gridList_MainFiltersContainer,
                {
                  backgroundColor: Theme.COLORS.BORDER_COLOR,
                  borderBottomWidth: 1,
                  borderColor: Theme.COLORS.MUTED,
                  justifyContent: "center",
                  height: 60,
                  paddingStart: 5,
                  paddingEnd: 5,
                },
              ]}
            >
              <InputSearch
                placeholder={translate("app.searchInOrderDetails")}
                value={this.state.orderDescriptionFilter}
                onChangeText={(txt) => {
                  this.setState({ orderDescriptionFilter: txt });
                }}
              />
            </View>
            {hasOrder == "Yes" && orderList.length != 0 && (
              <ScrollView
                style={{
                  flex: 1,
                  marginBottom: 85,
                }}
              >
                {orderList.map((o, i) => {
                  return (
                    <OrderListItem
                      onPress={() => this.handleOnItemPress(o.id, o.data)}
                      key={i}
                      orderData={o.data}
                      strService={o.data.numPublicServiceType}
                      toast={this.showToast}
                    />
                  );
                })}
              </ScrollView>
            )}
            {hasOrder == "No" && orderList.length == 0 && (
              <View
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 1,
                }}
              >
                {!this.state.reservationUser?.boolUserStatus && (
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: 18,
                      color: "#666666",
                    }}
                  >
                    {translate("api.disabledReservationUser")}
                  </Text>
                )}
                {this.state.reservationUser.boolUserStatus && (
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: 18,
                      color: "#666666",
                    }}
                  >
                    {translate("api.noOrderRequest")}
                  </Text>
                )}
              </View>
            )}
            {this.state.reservationUser?.boolUserStatus &&
              this.state.isParkingActive == true && (
                <TouchableHighlight
                  onPress={() => {
                    this.PressOnAddButton();
                  }}
                  color="primary"
                  iconColor="#fff"
                  shadowColor={true}
                  style={style.btnAdd}
                >
                  <FontAwesomeIcon icon={faPlus} color="#FFF" size={30} />
                </TouchableHighlight>
              )}
            {this.state.isParkingActive == false && (
              <View
                style={{
                  height: 60,
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: -70,
                  marginBottom: 10,
                }}
              >
                <Text style={{ fontWeight: "bold", fontSize: 18 }}>
                  {translate("api.inactiveService")}
                </Text>
              </View>
            )}
            {/* new order */}

            <ModalBase
              avoidKeyboard={true}
              isOpen={this.state.showModal === 1}
              onClose={() => this.hideModal()}
            >
              <View
                style={{
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  borderRadius: 5,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <View style={{ flex: 2, padding: 10 }}>
                    <Select
                      label={null}
                      data={[
                        {
                          label: translate("api.orderTypes.Parking"),
                          value: translate("api.orderTypes.Parking"),
                        },
                      ]}
                      value={translate("api.orderTypes.Parking")}
                    />
                  </View>
                  <View style={{ flex: 2, padding: 10 }}>
                    <Select
                      label={null}
                      data={this.state.areaList}
                      value={
                        Platform.OS == "web"
                          ? this.state.newOrderUnitId
                          : translate("api.orderUnit") ||
                            this.state.newOrderUnitId
                      }
                      onChangeText={(value, index, data) => {
                        this.setState({ isNewOrder: true });
                        if (Number.isInteger(value) || Number(value) > 0) {
                          this.setState({ newOrderUnitId: Number(value) }, () =>
                            this.getBalanceAmount(value)
                          );
                        }
                      }}
                    />
                  </View>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 7,
                    height: 250,
                  }}
                >
                  <View
                    style={{
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: 4,
                      padding: 10,
                      minHeight: 200,
                      height: "100%",
                      display: "flex",
                    }}
                  >
                    <View
                      style={{
                        flex: 1,
                        justifyContent: "center",
                        height: 800,
                        width: "100%",
                      }}
                    >
                      <View
                        style={{
                          // display: hasCredit ? "flex" : "none",
                          alignItems: "center",
                        }}
                      >
                        {this.state.parkingInfo != null && (
                          <Text>
                            {translate("parking.basePrice").concat(": ")}
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {englishToPersianNumber(
                                this.state.parkingInfo.numBasePrice,
                                ","
                              )}{" "}
                            </Text>
                            <Text>{translate("api.priceUnit")} </Text>
                          </Text>
                        )}
                        <View
                          style={{
                            marginTop: 8,
                            height: 37,
                            width: "100%",
                            marginBottom: 10,
                          }}
                        >
                          <Select
                            label={null}
                            data={paymentType_Options}
                            value={
                              Platform.OS == "web"
                                ? this.state.newOrderPaymentItem
                                : translate("api.paymentType") ||
                                  this.state.newOrderPaymentItem
                            }
                            onChangeText={(value, index, data) => {
                              if (Number(value) > 0) {
                                this.setState({
                                  newOrderPaymentItem: Number(value),
                                });
                              }
                            }}
                          />
                        </View>
                        <View
                          style={{
                            alignItems: "stretch",
                            width: "100%",
                            paddingTop: 8,
                          }}
                        >
                          <InputBase
                            label={translate("api.orderDescription")}
                            value={this.state.newOrderDescribe}
                            onChangeText={(text) => {
                              this.setState({ newOrderDescribe: text });
                            }}
                          />
                        </View>
                        <View
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <TouchableHighlight
                            onPress={() => {
                              if (this.state.isOrderRegistering) {
                                this.setState(
                                  { isOrderRegistering: false },
                                  this.registerParkingOrder()
                                );
                              }
                            }}
                            underlayColor={Theme.COLORS.BORDER}
                            style={{
                              borderColor: Theme.COLORS.BORDER,
                              borderWidth: 1,
                              backgroundColor: "#fff",
                              borderRadius: 3,
                              height: 37,
                              padding: 9,
                              width: 150,
                              marginTop: 10,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Text style={{ textAlign: "center" }}>
                              {translate("api.registration")}
                            </Text>
                          </TouchableHighlight>
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
            </ModalBase>
            {/* order Details */}
            <ModalBase
              avoidKeyboard={true}
              isOpen={this.state.showModal === 2}
              onClose={() => this.hideModal()}
            >
              <View style={style.modalInsideWrapper}>
                <View
                  style={
                    Platform.OS == "web"
                      ? style.webModalDetails
                      : style.appModalDetails
                  }
                >
                  {/* start Icons */}
                  <View
                    style={{
                      flexDirection: "row",
                      borderColor: Theme.COLORS.BORDER,
                      borderBottomWidth: 1,
                      height: 77,
                      width: "100%",
                    }}
                  >
                    {this.state.orderSelected != null && (
                      <IconButton
                        style={{
                          backgroundColor: "#ffffff",
                          width: 70,
                          height: 70,
                          borderRadius: 35,
                          borderWidth: 1,
                          borderColor: "#ccf",
                          marginStart: 22,
                          marginEnd: 22,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        icon={{
                          code: getIconPicture(
                            "facilityIcons",
                            this.state.orderSelected.numPublicServiceType
                          ),
                          style: {
                            fontFamily: FONT_FAMILIES.PRO_REGULAR,
                            fontSize: 30,
                            color: getIconPicture(
                              "facilityIcons",
                              this.state.orderSelected.numPublicServiceType
                            )
                              ? "#006666"
                              : "#ccc",
                          },
                        }}
                      />
                    )}
                    <View
                      style={{
                        flex: 1,
                        marginTop: 5,
                        flexDirection: "column",
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        {this.state.orderSelected != null && (
                          <Text style={{ paddingTop: 8 }}>
                            {translate("api.orderId")} :
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {" "}
                              {englishToPersianNumber(
                                this.state.orderSelected.numRequestID,
                                ""
                              )}
                            </Text>
                          </Text>
                        )}

                        {this.state.orderSelected != null && (
                          <Text style={{ paddingTop: 10 }}>
                            {this.state.orderSelected.strUnitName}
                          </Text>
                        )}
                      </View>
                    </View>
                    {this.state.orderSelected != null && (
                      <IconButton
                        style={{
                          // marginBottom: 20,
                          marginEnd: 20,
                          marginStart: 20,
                          backgroundColor: "#ffffff",
                          width: 70,
                          height: 70,
                          borderRadius: 35,
                          borderWidth: 1,
                          borderColor: "#ccf",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        icon={{
                          code: getIconPicture(
                            "statusOrder",
                            this.state.orderSelected.numRequestStatus
                          ),
                          style: {
                            fontFamily: FONT_FAMILIES.PRO_REGULAR,
                            fontSize: 30,
                            color: "#999",
                          },
                        }}
                      />
                    )}
                  </View>
                  {/* texts */}
                  <View
                    style={{
                      // flex: 1,
                      flexDirection: "column",
                      width: "85%",
                      paddingEnd: Platform.OS == "web" ? 0 : 20,
                      paddingStart: Platform.OS == "web" ? 0 : 20,
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "column",
                        justifyContent: "space-between",
                        paddingStart: 7,
                        paddingEnd: 7,
                        paddingTop: 5,
                      }}
                    >
                      {this.state.orderSelected != null && (
                        <Text style={{ fontWeight: "bold", marginBottom: 2 }}>
                          {translate("api.orderStatus")}:
                          {this.state.orderSelected.strRequestStatus}
                        </Text>
                      )}
                      <View
                        style={{
                          alignItems: "flex-end",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        {this.state.orderSelected != null && (
                          <Text>
                            {translate("api.orderSelectedDate")} :
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {" "}
                              {englishToPersianNumber(
                                this.state.orderSelected.dtRegPDate
                              )}
                            </Text>
                          </Text>
                        )}
                        {this.state.orderSelected != null && (
                          <Text>
                            {translate("api.orderSelectedTime")} :
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {" "}
                              {englishToPersianNumber(
                                this.state.orderSelected.dtRegTime
                              )}
                            </Text>
                          </Text>
                        )}
                      </View>
                      {this.state.orderSelected != null && (
                        <View
                          style={{
                            alignItems: "flex-end",
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <Text
                            style={{
                              paddingTop: 5,
                              alignItems: "flex-end",
                              fontWeight: "bold",
                              paddingBottom: 2,
                            }}
                          >
                            {translate("api.orderPrice")} :
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {" "}
                              {englishToPersianNumber(
                                this.state.orderSelected.numRequestPrice,
                                ","
                              )}{" "}
                            </Text>
                            <Text>{translate("api.priceUnit")}</Text>
                          </Text>
                        </View>
                      )}
                      <View
                        style={{
                          alignItems: "flex-end",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        {this.state.orderSelected != null && (
                          <Text>
                            {translate("api.paymentTypeString")}
                            {": "}
                            {translate(
                              "api.paymentTypeCode".concat(
                                ".",
                                this.state.orderSelected.payment.numPaymentType
                              )
                            )}
                          </Text>
                        )}
                        {this.state.orderSelected != null && (
                          <Text>
                            {translate("api.paymentStatusString")}
                            {": "}
                            {translate(
                              "api.paymentStatusCode".concat(
                                ".",
                                this.state.orderSelected.payment
                                  .numPaymentStatus
                              )
                            )}
                          </Text>
                        )}
                      </View>
                    </View>
                    {this.state.orderSelected != null && (
                      <View
                        style={{
                          flex: 1,
                          width: SCREEN_WIDTH * 0.8,
                          flexDirection: "column",
                          paddingBottom: 10,
                          height: 20,
                          marginBottom: Platform.OS == "web" ? 10 : 50,
                          marginTop: 10,
                        }}
                      >
                        <InputBase
                          isDisabled={true}
                          value={
                            this.state.orderSelected?.strRequestDesc || "-"
                          }
                          label={translate("api.orderDescription")}
                        />
                      </View>
                    )}
                  </View>
                  {/* end buttons */}
                  <View
                    style={{
                      alignItems: "center",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <View
                      style={{
                        // paddingEnd: 10,
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      {this.state.orderSelected?.numRequestStatus == 1 && (
                        <TouchableHighlight
                          underlayColor={Theme.COLORS.BORDER}
                          onPress={() => {
                            this.setState({ isShowingCancelAlert: true });
                          }}
                          style={{
                            borderColor: Theme.COLORS.BORDER,
                            borderWidth: 1,
                            backgroundColor: "#fff",
                            borderRadius: 3,
                            height: 37,
                            marginBottom: 15,
                            padding: 9,
                            marginEnd: 30,
                            width: 150,
                          }}
                        >
                          <Text style={{ textAlign: "center" }}>
                            {translate("app.alertTitleCancel")}
                          </Text>
                        </TouchableHighlight>
                      )}
                      <TouchableHighlight
                        underlayColor={Theme.COLORS.BORDER}
                        onPress={() => this.hideModal()}
                        style={{
                          borderColor: Theme.COLORS.BORDER,
                          borderWidth: 1,
                          backgroundColor: "#fff",
                          borderRadius: 3,
                          height: 37,
                          marginBottom: 15,
                          padding: 9,
                          width: 150,
                        }}
                      >
                        <Text style={{ textAlign: "center" }}>
                          {translate("api.closeOrderSelected")}
                        </Text>
                      </TouchableHighlight>
                      {this.state.isShowingCancelAlert && (
                        <AlertDialogBase
                          isOpen={true}
                          title={translate("app.alertTitleCancel")}
                          confirmText={translate("app.confirm")}
                          colorConfirm="primary"
                          confirmHandler={() => {
                            this.cancelOrder();
                            this.hideCancelConfirm();
                          }}
                          onClose={() => {
                            this.hideCancelConfirm();
                          }}
                        >
                          <Text>{translate("api.isConfirmCancel")}</Text>
                        </AlertDialogBase>
                      )}
                    </View>
                  </View>
                </View>
              </View>
            </ModalBase>
          </View>
        )}
      </KeyboardAvoidingView>
    );
  }
}
const style = StyleSheet.create({
  btnAdd: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: Theme.COLORS.PRIMARY,
    position: "absolute",
    bottom: 15,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  modalInsideWrapper: {
    backgroundColor: "#FFF",
    borderRadius: 10,
    margin: 0,
    marginBottom: 0,
    paddingTop: 15,
    alignItems: "center",
  },
  webModalDetails: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 310,
    marginTop: 7,
    width: "100%",
  },
  appModalDetails: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 310,
    marginTop: 7,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.ApiReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    MyOrders: (accessToken) => dispatch(Actions.MyParkingOrders(accessToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ParkingScreen);
